export default __webpack_public_path__ + "static/嘉宾头像_王君轶-89013cd21de537b2cf05b9b999b8431a.png";